import React, { Component } from 'react';
import i from '../imports';

const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <i.Icon className={className} onClick={onClick} icon={props.icon} size="22" style={{color: props.navColor || "#FF5560", cursor: "pointer"}}/>
    );
}

class Slider extends Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        let items = this.props.items.map(i => i);
        return (
            <i.SlickSlider
                className='animated fadeIn'
                autoplay={this.props.autoplay}
                slidesToShow={this.props.slidesToShow}
                infinite={true}
                swipeToSlide={true}
                centerMode={true}
                className={this.props.className}
                prevArrow={<SamplePrevArrow icon={i.faIcons.chevronLeft} navColor={this.props.navColor} />}
                nextArrow={<SamplePrevArrow icon={i.faIcons.chevronRight} navColor={this.props.navColor} />}
            >
                {
                    items.map((item, index) => React.createElement( this.props.itemComponent, {key: index, item, itemIndex: index, totalItems: items.length}))
                }
            </i.SlickSlider>
        );
    }
}

export default Slider;